package com.hyperether.goodjob.database

import app.cash.sqldelight.async.coroutines.awaitAsList
import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.hyperether.goodjob.repository.Mapper
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow

class TeamDaoImpl(private val sharedDatabase: SharedDatabase) : TeamDao {

    override suspend fun insertTeam(team: com.hyperether.goodjob.models.Team) {
        sharedDatabase { database ->
            database.appDatabaseQueries.transaction {
                database.appDatabaseQueries.insertTeam(
                    _id = team._id,
                    name = team.name,
                    employees = Mapper().listAsJson(team.employees),
                    workspaceId = team.workspaceId,
                    type = team.type,
                    updatedAt = team.updatedAt.toString(),
                    createdAt = team.createdAt.toString()
                )
            }
        }
    }

    override suspend fun getTeamsFlow(): Flow<List<Team>> {
        return sharedDatabase { database ->
            database.appDatabaseQueries
                .getTeams()
                .asFlow()
                .mapToList(Dispatchers.Default)
        }
    }


    override suspend fun getTeamsFromLocal(): List<Team> =
        sharedDatabase { database ->
            database.appDatabaseQueries.getTeams().awaitAsList()
        }

    override suspend fun updateTeamById(team: com.hyperether.goodjob.models.Team) {
        sharedDatabase { database ->
            database.appDatabaseQueries.transaction {
                database.appDatabaseQueries.updateTeamByID(
                    _id = team._id,
                    id = team._id,
                    name = team.name,
                    employees = Mapper().listAsJson(team.employees),
                    type = team.type,
                    workspaceId = team.workspaceId,
                    updatedAt = team.updatedAt.toString(),
                    createdAt = team.createdAt.toString()
                )
            }
        }
    }

    override suspend fun deleteTeamById(id: String) {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteTeamById(id)
        }
    }

    override suspend fun deleteAllTeams() {
        sharedDatabase { database ->
            database.appDatabaseQueries.deleteAllTeams()
        }
    }
}